var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/status-media.tsx";
import React, { useCallback, useMemo, useState } from 'react';
import { openModal } from 'soapbox/actions/modals';
import AttachmentThumbs from 'soapbox/components/attachment-thumbs';
import Audio from 'soapbox/features/audio';
import PlaceholderCard from 'soapbox/features/placeholder/components/placeholder_card';
import Card from 'soapbox/features/status/components/card';
import Video from 'soapbox/features/video';
import { useAppDispatch } from 'soapbox/hooks';
import MediaGallery from './media_gallery';
/** Render media attachments for a status. */
const StatusMedia = ({
  status,
  muted = false,
  onClick,
  showMedia = true,
  onToggleVisibility = () => {}
}) => {
  const dispatch = useAppDispatch();
  const [mediaWrapperWidth, setMediaWrapperWidth] = useState(undefined);
  const size = useMemo(() => status.media_attachments.size, [status.media_attachments]);
  const firstAttachment = useMemo(() => status.media_attachments.first(), [status.media_attachments]);
  let media = null;
  const setRef = useCallback(c => {
    if (c) {
      setMediaWrapperWidth(c.offsetWidth);
    }
  }, []);
  const openMedia = useCallback((media, index) => {
    dispatch(openModal('MEDIA', {
      media,
      index
    }));
  }, [dispatch]);
  const openVideo = useCallback((media, time) => {
    dispatch(openModal('VIDEO', {
      media,
      time
    }));
  }, [dispatch]);
  if (size > 0 && firstAttachment) {
    if (muted) {
      media = /*#__PURE__*/React.createElement(AttachmentThumbs, {
        media: status.media_attachments,
        onClick: onClick,
        sensitive: status.sensitive,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63,
          columnNumber: 9
        }
      });
    } else if (size === 1 && firstAttachment.type === 'video') {
      const video = firstAttachment;
      if (video.external_video_id && status.card) {
        const getHeight = () => {
          const width = Number(video.meta.getIn(['original', 'width']));
          const height = Number(video.meta.getIn(['original', 'height']));
          return Number(mediaWrapperWidth) / (width / height);
        };
        const height = getHeight();
        media = /*#__PURE__*/React.createElement("div", {
          className: "status-card horizontal compact interactive status-card--video",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 82,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement("div", {
          ref: setRef,
          className: "status-card__image status-card-video",
          style: height ? {
            height
          } : undefined,
          dangerouslySetInnerHTML: {
            __html: status.card.html
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 83,
            columnNumber: 13
          }
        }));
      } else {
        media = /*#__PURE__*/React.createElement(Video, {
          preview: video.preview_url,
          blurhash: video.blurhash,
          src: video.url,
          alt: video.description,
          aspectRatio: video.meta.getIn(['original', 'aspect']),
          height: 285,
          inline: true,
          sensitive: status.sensitive,
          onOpenVideo: openVideo,
          visible: showMedia,
          onToggleVisibility: onToggleVisibility,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 93,
            columnNumber: 11
          }
        });
      }
    } else if (size === 1 && firstAttachment.type === 'audio') {
      const attachment = firstAttachment;
      media = /*#__PURE__*/React.createElement(Audio, {
        src: attachment.url,
        alt: attachment.description,
        poster: attachment.preview_url !== attachment.url ? attachment.preview_url : status.getIn(['account', 'avatar_static']),
        backgroundColor: attachment.meta.getIn(['colors', 'background']),
        foregroundColor: attachment.meta.getIn(['colors', 'foreground']),
        accentColor: attachment.meta.getIn(['colors', 'accent']),
        duration: attachment.meta.getIn(['original', 'duration'], 0),
        height: 263,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 112,
          columnNumber: 9
        }
      });
    } else {
      media = /*#__PURE__*/React.createElement(MediaGallery, {
        media: status.media_attachments,
        sensitive: status.sensitive,
        height: 285,
        onOpenMedia: openMedia,
        visible: showMedia,
        onToggleVisibility: onToggleVisibility,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125,
          columnNumber: 9
        }
      });
    }
  } else if (status.spoiler_text.length === 0 && !status.quote && status.card) {
    media = /*#__PURE__*/React.createElement(Card, {
      onOpenMedia: openMedia,
      card: status.card,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 137,
        columnNumber: 7
      }
    });
  } else if (status.expectsCard) {
    media = /*#__PURE__*/React.createElement(PlaceholderCard, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 144,
        columnNumber: 7
      }
    });
  }
  return media;
};
export default StatusMedia;